import dayjs from "dayjs";

import { Get } from "./apiAxios";
import { IProvinceMaster, ITruckClassMaster } from "@interface/ICommon";
import {
  IPlanTime,
  IResponsePlanSchedule,
  ITimeSchedule,
} from "@components/Form/interface";
import axiosInstance from "./config";
import countryLangStore from "@zustand/countryLang";
import { formatYearMonthDay } from "@constants/format";
import { masterOriginDto } from "@utils/manageData";
import { renderMasterPlant } from "@methods/master.method";

export const GetMasterSamantraPlant = async () => {
  const res = await Get({ urlPath: "/samantra-rest/plant" });
  const { status, message } = res;
  if (status) {
    return message;
  } else {
    return [];
  }
};

export const fetchProductWithVendorCode = async (vendorCode: string) => {
  const res = await Get({
    urlPath: `/master/samantra-rest/product_group2vendor/${vendorCode}/${dayjs().format(
      formatYearMonthDay,
    )}`,
  });
  return renderMasterPlant(res);
};

export const fetchMillVendorData = async (vendorCode: string) => {
  const res = await Get({
    urlPath: `/master/mill/get-vendor/${vendorCode}`,
  });

  return res;
};

export const fetchPlantsData = async () => {
  const res = await Get({
    urlPath: `/master/samantra-rest/plant`,
  });
  const { status, message } = res;
  if (status) {
    return message;
  } else {
    return [];
  }
};

export const fetchFactoryTraderRole = async (id: number) => {
  const res = await Get({ urlPath: `/factory-trader-role/${id}` });
  const { status, message } = res;
  if (status) {
    return message;
  } else {
    return [];
  }
};

export const fetchMasterTransportation = async () => {
  const resVehicleType = await Get({
    urlPath: `/master/master-transportation`,
  });
  const { status, message } = resVehicleType;
  if (status) {
    const vehicleTypeOption = message?.map((val: ITruckClassMaster) => {
      return {
        label: val?.vehicle_class_name,
        value: val?.id,
        ...val,
      };
    });
    return vehicleTypeOption;
  } else {
    return [];
  }
};

export const GetVenderDetail = async (vendor: string) => {
  try {
    const res = await Get({ urlPath: `/vendor/${vendor}`, auth: true });
    const { status, message } = res;
    if (status && message?.Data) {
      return message?.Data[0];
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching vendor details:>>", error);
    return null;
  }
};

export const GetFactoryTraderByVendor = async (vendor_no: string) => {
  const res = await Get({
    urlPath: `/factory-trader-role-vendor/${vendor_no}`,
    auth: true,
  });
  return res;
};

export const getBookingData = async (
  date: string,
  factory_code: string,
  product_code: string,
) => {
  try {
    const res = await Get({
      urlPath: `/plan_schedule/${date}/${factory_code}/${product_code}`,
      auth: true,
    });
    const { status, message } = res;
    if (status) {
      const setBooking: any[] = [];
      message.forEach((val: any) => {
        val.plan_time.map((valTime: any) => {
          setBooking.push({
            location: val.location,
            time: valTime.time,
            available: valTime.available,
          });
        });
      });

      return setBooking;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching booking data:", err);
    return [];
  }
};

export const getScheduleData = async (query?: string) => {
  try {
    const res = await Get({
      urlPath: `/plan_schedule${query ?? ""}`,
      auth: true,
    });
    const { status, message } = res;
    if (status) {
      const setBooking: ITimeSchedule[] = [];
      message.forEach((val: IResponsePlanSchedule) => {
        val.plan_time.forEach((valTime: IPlanTime) => {
          setBooking.push({
            location: val.location,
            time: valTime.time,
            available: valTime.available,
          });
        });
      });

      return setBooking;
    } else {
      return [];
    }
  } catch (err) {
    console.error("Error fetching schedule data:", err);
    return [];
  }
};

export const GetConfig = async (params: string) => {
  const res = await Get({ urlPath: `/config-qovis?${params}`, auth: true });
  return res;
};

export const fetchMasterMethod = async () => {
  const res = await Get({
    urlPath: `/master-method-information`,
    auth: true,
  });
  const { status, message } = res;
  if (status) {
    return message;
  } else {
    return [];
  }
};
export const fetchMasterOrigin = async () => {
  const res = await Get({
    urlPath: `/master-origin-information`,
    auth: true,
  });
  const { status, message } = res;
  if (status) {
    return masterOriginDto(message);
  } else {
    return [];
  }
};

export const getConfigMaintenance = async (params: string) => {
  const country = countryLangStore?.getState()?.country?.id;
  if (country === 0 || !country)
    return {
      status: false,
      message: "Country not selected",
    };
  const country_id = { country_id: country };
  const ApiDomain = process.env.REACT_APP_API_DOMAIN || "";
  const url = ApiDomain + `/system-maintenance?${params}`;

  return axiosInstance({
    method: "GET",
    url,
    headers: {
      ...country_id,
    },
  })
    .then((res) => {
      return {
        status: true,
        message: res.data,
      };
    })
    .catch((err) => {
      return {
        status: false,
        message: err,
      };
    });
};

export const fetchMasterProvince = async () => {
  const resVehicleType = await Get({
    urlPath: `/master/master-province`,
  });
  const { status, message } = resVehicleType;
  if (status) {
    const provinceTypeOption = message?.map((val: IProvinceMaster) => {
      return {
        label: val.province,
        value: val.short_name,
      };
    });
    return provinceTypeOption;
  } else {
    return [];
  }
};

export const fetchMasterVendorPublic = async (vendor: string) => {
  try {
    const res = await Get({ urlPath: `/master/vendor/${vendor}` });
    const { status, message } = res;
    if (status && message?.Data) {
      return message?.Data[0];
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching vendor details:>>", error);
    return null;
  }
};
